export default __webpack_public_path__ + "static/media/adult-entertainment-header.37dd98f8.png";